import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';

import * as SmoothAccessActions from './../actions/smooth-access.actions';
import { SmoothAccessService } from '../../services/smooth-access.service';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';

@Injectable({
  providedIn: 'root',
})
export class SmoothAccessEffects {
  @Effect()
  disneyPlusDetails$ = this.actions$.pipe(
    ofType(SmoothAccessActions.GET_DISNEY_PLUS_DETAILS),
    mergeMap((action: SmoothAccessActions.GetDisneyPlusDetails) =>
      this.smoothAccessService.getDisneyPlusDetails(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new SmoothAccessActions.GetDisneyPlusDetailsSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new SmoothAccessActions.GetDisneyPlusDetailsFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private smoothAccessService: SmoothAccessService,
  ) {}
}
